import manGray from 'src/assets/action-plan/man-gray.png';
import manRed from 'src/assets/action-plan/man-red.png';

export const styles = {
  kpiHistory: {
    flexGrow: 1,
  },

  headline: {
    bgcolor: '#ffcc00',
    color: '#d40511',
    textAlign: 'center',
    padding: 1.5,
  },

  workers: {
    display: 'flex',
    justifyContent: 'space-between',
    py: 2.25,
    px: 0,
  },

  worker: (plan: boolean, bigKpi: boolean) => ({
    height: '30px',
    width: '30px',
    backgroundSize: 'contain',
    backgroundImage: `url(${manGray})`,
    ...(plan && {
      backgroundImage: `url(${manRed})`,
    }),
    ...(bigKpi && {
      height: '50px',
      width: '50px',
    }),
  }),

  chart: {
    height: '200px',
  },
};
